import { HttpInterceptorFn, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { SecurityService } from '../services/security.service';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, switchMap, take, filter, tap } from 'rxjs/operators';

let isRefreshing = false;
let refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const securityService = inject(SecurityService);

  const addToken = (req: HttpRequest<any>, token: string) => {
    return req.clone({
      setHeaders: {
        token: token,
      },
    });
  };

  const excludeUrls = ['/checkSession', '/checkSessionUpdatingDate', '/getNewSession', '/resumeSession','/setConsultor', '/setConsultorUpdatingData', '/app/whatsapp/verifySessionWhatsapp'];
  if (excludeUrls.some(url => request.url.includes(url))) {
    return next(request);
  }

  const session = localStorage.getItem('session');
  const consultor = localStorage.getItem('consultor');

  if (!session && consultor) {
    return securityService.getNewSession(consultor).pipe(
      take(1),
      switchMap((response: any) => {
        if (response.ok && response.session) {
          localStorage.setItem('session', response.session);
          const newRequest = addToken(request, response.session);
          return next(newRequest);
        }
        return throwError(() => new Error('Error al obtener sesión'));
      }),
      catchError(error => {
        localStorage.removeItem('consultor');
        router.navigate(['/']);
        return throwError(() => error);
      })
    );
  }

  if (!session) {
    return next(request);
  }

  const clonedRequest = addToken(request, session);

  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return handleAuthError(request, next, securityService, router);
      }
      return throwError(() => error);
    })
  );
};

export function handleAuthError(
  request: HttpRequest<any>,
  next: any,
  securityService: SecurityService,
  router: Router
): Observable<any> {
  const consultor = localStorage.getItem('consultor');

  localStorage.clear();

  isRefreshing = true;
  refreshTokenSubject.next(null);

  return securityService.getNewSession(consultor).pipe(
    take(1),
    switchMap((response: any) => {
      if (response.ok && response.session) {
        localStorage.setItem('session', response.session);
        refreshTokenSubject.next(response.session);
        isRefreshing = false;

        const newRequest = request.clone({
          setHeaders: {
            token: response.session,
          },
        });
        return next(newRequest);
      }
      isRefreshing = false;
      return throwError(() => new Error('Error al renovar sesión'));
    }),
    catchError((err) => {
      isRefreshing = false;
      localStorage.removeItem('session');
      localStorage.removeItem('consultor');
      router.navigate(['/']);
      return throwError(() => err);
    })
  );
}
